export function generateTemplates(firstViewField, engineApi, treeNodes) {
  const dicTemplates = {};

  generateTemplate(firstViewField);
  return dicTemplates;

  function generateTemplate(viewField) {
    if (!treeNodes.includes(viewField.model)) {
      return;
    }
    const template = generateObject(viewField, engineApi, treeNodes);
    dicTemplates[viewField.model] = template;
    (viewField.properties || []).forEach(property => {
      property.parent = viewField;
      generateTemplate(property);
    });
  }
}

function generateObject(viewField, engineApi, treeNodes) {
  const eTmp = engineApi.register.setCommonAttributes('ec-flex-rows', viewField, engineApi);
  const clone = Object.assign({}, viewField);
  clone.properties = (viewField.properties || [])
    .filter(property => !treeNodes.includes(property.model || ''))
    // @odeniel borramos los hijos que no queremos pintarlos
    // @odeniel borramos el fbFlash a todos los hijos (especialmente los grids)
    .map(property => Object.assign({}, property, { /*properties: [], */ fbFlash: false, parent: viewField }));
  eTmp.appendChild(engineApi.handleProperties(clone, engineApi));
  return eTmp.getHtml();
}
